import Saurabh from "./../assets/carouselImages/Mr-Saurabh.webp";
import Umesh from "./../assets/carouselImages/Umesh-Biyani.webp";
import Archit from "./../assets/carouselImages/Archit.webp";
import Sanam from "./../assets/carouselImages/Sanam-Munot.webp";
import Anshul from "./../assets/carouselImages/Anshul-Dhanuka.webp";
import SujitBaral from "./../assets/carouselImages/sujit-baral.webp";
import Rajesh from "./../assets/carouselImages/Rajesh-Sharma.webp";
import Devinjit from "./../assets/carouselImages/Devinjit-Singh.webp";
import Srinivasan from "./../assets/carouselImages/PR-Srinivasan.webp";
import Sanjay from "./../assets/carouselImages/Sanjay-Jain.webp";
import Pratik from "./../assets/carouselImages/Pratik-Lakhotia.webp";
import Varuna from "./../assets/carouselImages/Varuna-Agarwal.webp";
import Tejal from "./../assets/carouselImages/Tejal-Mishra.webp";
import Yesha from "./../assets/carouselImages/Yesha-Poudwal.webp";
import Media2 from "./../assets/new_media/News_2.webp";
import Media3 from "./../assets/new_media/News_3.webp";
import Media4 from "./../assets/new_media/News_4.webp";
import Media5 from "./../assets/carouselImages/Sanjay-Jain.webp";
import Media6 from "./../assets/new_media/News_5.webp";
import Media7 from "./../assets/new_media/News_6.webp";

export const MediaData = [
    {
    image: Media7,
    time: "2026-02-19T07:30:00Z",
    heading:
      "Bottomline: How PE-Backed Deepak Fasteners Staged A Turnaround After Years Of Losses",
    description:
      "",
    url: "https://www.vccircle.com/bottomlinehow-pe-backed-deepak-fasteners-staged-a-turnaround-after-years-of-losses",
  },
    {
    image: Media3,
    time: "2026-02-18T07:30:00Z",
    heading:
      "Capri Group appoints Sanjay Jain as managing partner for sponsored stressed-asset funds",
    description:
      "Sanjay Jain will join the investment manager as managing partner for its funds subject to investor and SEBI approvals",
    url: "https://www.thehindubusinessline.com/money-and-banking/sanjay-jain-to-join-investment-manager-of-capri-groups-two-alternative-investment-funds/article70643700.ece",
  },
  {
    image: Media6,
    time: "2026-02-17T07:30:00Z",
    heading:
      "Capri Global Investment's joint stressed assets fund crosses halfway mark; boosts team",
    description:
      "",
    url: "https://www.vccircle.com/caprixponentia-s-joint-stressed-assets-fund-crosses-halfway-mark-boosts-team",
  },
  {
    image: Media5,
    time: "2026-02-17T07:30:00Z",
    heading:
      "Sanjay Jain to join Investment Manager of Capri group’s two alternative investment funds",
    description:
      "Jain has over three decades of experience across stressed assets, capital markets, investment banking and corporate and project lease finance.",
    url: "https://www.thehindubusinessline.com/money-and-banking/sanjay-jain-to-join-investment-manager-of-capri-groups-two-alternative-investment-funds/article70643700.ece",
  },
  {
    image: Media2,
    time: "2024-12-05T08:30:00Z",
    heading: "Capri Stressed Assets Fund Commits $48M in Debt Investment",
    description:
      "Capri Stressed Assets Fund commits $48 million in debt investment in Unbrako brand owner Deepak Fasteners Ltd.",
    url: "https://www.thecfigroup.com/transactions/capri-stressed-assets-fund-commits-48-mn-in-debt-investment-in-unbrako-brand-owner-deepak-fasteners-ltd/",
  },
  {
    image: Media3,
    time: "2024-12-05T08:00:00Z",
    heading: "Capri Stressed Assets Fund Invests ₹375 Cr in Unbrako Fasteners",
    description:
      "Capri Stressed Assets Fund invests ₹375 crore in Unbrako-branded fasteners to expand their reach globally.",
    url: "https://bwdisrupt.com/article/capri-stressed-assets-fund-invests-rs-375-cr-in-unbrako-fasteners-432576",
  },
  {
    image: Media4,
    time: "2024-12-05T07:30:00Z",
    heading:
      "Capri Global's Shares Surge Over 15% After Insurance Licence Approval",
    description:
      "Capri Global Capital's shares surged over 15% after receiving a corporate agency licence to sell insurance products.",
    url: "https://www.equitypandit.com/capri-global-capitals-shares-surged-over-15-after-getting-a-corporate-agency-licence-to-sell-insurance-products/",
  }
];

export const TeamsData = {
  "Leadership Teams": [
    {
      image: Sanjay,
      name: "Sanjay Jain",
      role: "Managing Director & CIO",
      description:
        "Sanjay Jain is the Managing Director & CIO with over 30 years of experience spanning stressed assets, listed equities, investment banking including DCM, ECM and M&A, and project and corporate finance. As CEO of Aditya Birla ARC Ltd., he oversaw investments of approximately INR 60 billion in stressed assets, all of which were resolved with returns exceeding 40% IRR and over INR 105 billion in total returns, with KSK Mahanadi Power Ltd. being a marquee deal. Prior to this, he served as President & COO at ARCIL and as MD & Head of Global Capital Markets at JM Financial, having begun his career at SBI Capital Markets. Sanjay Jain is a Chartered Accountant qualified from ICAI in November 1991, having secured 1st Rank in CA Intermediate and 8th Rank in CA Final",
    },
    {
      image: Srinivasan,
      name: "P. R. Srinivasan",
      role: "Partner",
      description:
        "P. R. Srinivasan is the Designated Partner of Capri Global Investment Managers LLP. He brings in three decades of experience as an investment professional to the entity. PRS is the co-founder of Global Investment Capital Partners LLP, an investment firm that manages over INR 1,500 crores of assets across two funds: Global Investment Opportunities Fund -1 (XOF-1) and Global Investment Opportunities Fund -2 (XOF-2). Prior to founding Global Investment Capital Partners LLP, PRS was the Managing Director at Citi Venture Capital International for around 8 years (2002 - 2010). During this stint, he managed a portfolio of USD 1 billion, which included investments in Axis Bank, Yes Bank, Suzlon, Lupin, GMR and Sharekhan. PRS is also the co-founder of HSBC India Private Equity, where he raised and managed a total of USD 60 million in 1995. Some of the marquee investments that he made during his time at HSBC included names like Dishnet, Kurlon, Sharekhan and Millennium Software. P. R. Srinivasan is an alumnus of Anna University, where he did his B.E. in Mechanical Engineering, and of the Indian Institute of Management - Bangalore, where he completed his M.B.A. in Finance.",
    },
    {
      image: Devinjit,
      name: "Devinjit Singh",
      role: "Partner",
      description:
        "Devinjit Singh, Managing Partner at Capri Global Investment Managers LLP, has rich experience in the mid-market Private Equity industry spanning over 30 years. Along with P. R. Srinivasan, he co-founded Global Investment Capital Partners LLP, an investment firm that manages over INR 1,500 crores of assets. Prior to founding Global Investment Capital Partners LLP, Devinjit worked as the Managing Director of Carlyle Asia Partners for 10 years. During this time, he invested more than USD 1 billion in multiple entities, including marquee investments in PNB Housing Finance and SBI Card, which became some of the most successful private equity transactions in India. Before joining Carlyle Asia Partners, Devinjit was the Managing Director of Citi India, where he headed the M&A team. While at Citi, he made landscape-changing deals in leading Indian corporations with Tata Motors, L&T, Wipro and HDFC. Devinjit holds a Bachelor’s degree in Mathematics from Hindu College, New Delhi and a Master’s degree in Business Administration from The Fuqua School of Business of Duke University, U.S.A.",
    },
    {
      image: Rajesh,
      name: "Rajesh Sharma",
      role: "Partner",
      description:
        "A first-generation entrepreneur, Rajesh Sharma is one of the Designated Partners of Capri Global Investment Managers LLP. He is also the founder and Managing Director of Capri Global Capital Limited (CGCL), one of India’s leading Non-Banking Financial Companies (NBFCs). Under his guidance, the NBFC currently has a strong foothold in the country, with over 3,80,000 customers, 935 branches across 32 states and a total loan book value of more than INR 15,000 crores. Leveraging his experience of more than 25 years in the Indian financial industry, Rajesh has played an instrumental role in raising more than INR 4,500 crores worth of debt for various Indian corporates across sectors. A qualified Chartered Accountant, Rajesh Sharma’s vision for Capri Global Investment Managers LLP is to tap into the approximately INR 1 trillion mid-market stressed assets space for risk-adjusted yet outsized returns on investments.",
    },
  ],
  "Investment Teams": [
    {
      image: Sanjay,
      name: "Sanjay Jain",
      role: "Managing Director & CIO",
      description:
        "Sanjay Jain is the Managing Director & CIO with over 30 years of experience spanning stressed assets, listed equities, investment banking including DCM, ECM and M&A, and project and corporate finance. As CEO of Aditya Birla ARC Ltd., he oversaw investments of approximately INR 60 billion in stressed assets, all of which were resolved with returns exceeding 40% IRR and over INR 105 billion in total returns, with KSK Mahanadi Power Ltd. being a marquee deal. Prior to this, he served as President & COO at ARCIL and as MD & Head of Global Capital Markets at JM Financial, having begun his career at SBI Capital Markets. Sanjay Jain is a Chartered Accountant qualified from ICAI in November 1991, having secured 1st Rank in CA Intermediate and 8th Rank in CA Final",
    },
    {
      image: Saurabh,
      name: "Saurabh Johri",
      role: "Managing Director",
      description:
        "Saurabh has extensive background in financial management and investment, having served as the CEO and Executive Director at Caspian, where he managed two Alternative Investment Funds (AIFs) and a Netherlands-based fund. During his tenure, he made equity investments in companies, and successfully exited investments, including the acquisition of Sonata Microfinance by Kotak Bank for INR 5.3 billion. Additionally, he raised INR 45 billion in equity and INR 10 billion in long-term debt from marquee investors and Development Finance Institutions (DFIs) while working at Jana Small Finance Bank and Caspian. Earlier in his career, he was a member of the corporate strategy team at Infosys Limited from 2006 to 2010. Saurabh holds a Bachelor of Technology degree from IIT Varanasi and an MBA from Ohio State University, USA.",
    },
    {
      image: Umesh,
      name: "Umesh Biyani",
      role: " Director",
      description:
        "Umesh is part of the investments team at Capri Stressed Assets Fund. He is a rank-holder Chartered Accountant from the Institute of Chartered Accountants of India and also holds the CFA degree from the Institute of Chartered Financial Analysts of India. Umesh has over 24 years of experience in stressed asset investment and management and business/management consulting. During his stint at Asset Reconstruction Company (India) Limited, International Asset Reconstruction Company Private Limited and others, Umesh was instrumental in the acquisition and management of the portfolio of large and mid-sized companies, with an aggregate debt of over INR 7,000 crore. He was also instrumental in acquiring and designing strategy for successful resolution of large corporate assets. Umesh has assisted several companies in their turnaround efforts, providing business process reengineering and financial restructuring advisory services. He has assisted stressed corporate entities in raising funds to facilitate settlement and in the financial restructuring of aggregate debt of over INR 7,500 crore.",
    },
    {
      image: Anshul,
      name: "Anshul Dhanuka",
      role: "Sr. Vice President",
      description:
        "Anshul Dhanuka is part of the Investment Team at Capri Global Investment Managers LLP. He is a qualified Chartered Accountant and Company Secretary, and holds a B.Com degree from St. Xavier’s College, Kolkata. Anshul is a finance and strategy professional with over 13 years of experience. Prior to joining Capri Global Investment Managers LLP, he has worked with Kotak Mahindra Bank, Alvarez & Marsal, Ernst & Young, and the Vedanta Group.",
    },
    {
      image: SujitBaral,
      name: "Sujit Baral",
      role: "Vice President",
      description:
        "Sujit Baral brings 13+ years of experience across SP Investment Advisors Pvt Ltd, Asset Reconstruction Company (India) Limited, Axis Bank, and Infosys, spanning buy-side investing, distressed credit, and corporate lending. He has a strong track record in special situations and structured credit, with approximately $500M deployed and $10Bn+ evaluated across sectors, including hands-on experience in valuation, restructuring, and deal execution. Most recently VP at SP Investment Advisors, he led more than $1Bn of real estate investment evaluation and managed approximately 3 mn sq. ft. of Grade A assets across the full lifecycle (origination to exit). A CFA Charterholder with deep expertise in financial modelling, credit underwriting, and legal frameworks (IBC, SARFAESI), he now brings this experience to Capri Global Investment Managers LLP.",
    },
    {
      image: Archit,
      name: "Archit Varma",
      role: " Senior Investment Manager",
      description:
        "Archit Varma is part of the investment team at Capri Global Investment Managers LLP. He has 7 years of experience in the financial services industry, out of which he spent more than 4 years dealing with stressed assets and special situations. Archit is an alumnus of EDHEC Business School, from where he holds a Master's degree in Asset Management, as well as an alumnus of the University of London, where he completed his B.Sc. in Economics and Finance. Prior to Capri Global Investment Managers LLP, Archit worked as an Assistant Manager at Shuttl, where he handled investor relations and fundraising. His other stints include working as an investment banking analyst at Capital Fortunes and as an associate at Special Situation Advisors (India) Pvt. Ltd.",
    },
    {
      image: Pratik,
      name: "Pratik Lakhotia",
      role: "Investments, Capri Stressed Assets Fund",
      description:
        "Pratik Lakhotia is a member of the Investments Team at Capri Stressed Assets Fund, where he focuses on evaluating and executing investments across stressed assets, special situations, and debt/equity financing opportunities.",
    },
  ],
  "Operations Team": [
    {
      image: Varuna,
      name: "Varuna Agarwal",
      role: "Compliance Officer",
      description:
        "Varuna has 5+ years of overall experience across diverse roles. Previously worked at SecMark Consultancy Limited with a focus on AIF and PMS Compliances. Before that, worked as a consultant for SOX Compliances at Vedanta Limited. Company Secretary, CA Finalist",
    },
    {
      image: Tejal,
      name: "Tejal Mishra",
      role: "Finance & Fund Operations",
      description:
        "Tejal is a Chartered Accountant with 5 years of experience in fund operations and corporate finance. At Capri Global Investment Managers LLP, she is responsible for finance and Fund operations.",
    },
    {
      image: Yesha,
      name: "Yesha Poudwal",
      role: "Operations & Administration",
      description:
        "Yesha has over 18 years of experience in operations, administration, and executive support across the financial services and technology sectors.",
    },
  ],
};

export const HomeData = [
  {
    image: Sanjay,
    name: "Sanjay Jain",
    title: "Managing Director & CIO",
  },
  {
    name: "Saurabh Johri",
    title: "Managing Director",
    image: Saurabh,
  },
  {
    image: Umesh,
    name: "Umesh Biyani",
    title: " Director",
  },
  {
    image: Archit,
    name: "Archit Varma",
    title: " Senior Investment Manager",
  },
  {
    name: "Sanam Munot",
    title: "Senior Investment Manager",
    image: Sanam,
  }
];
